import { TimesHttpHelper, NO_DATA_MESSAGE } from '@usas/ui-web/utils/HttpHelper';

const DeleteRecordTimeData = (swimTimeRecordId, state, setState) => {
  if (state.isObjLoading !== true && !state.message) {
    const newState = {
      ...state,
      isObjLoading: true,
      isObjLoaded: false,
      isSaving: true,
      isSaved: false,
      objData: {},
      message: 'Deleting...'
    };
    setState(newState);

    const swimTimeRecordIdForUrl = swimTimeRecordId ? encodeURIComponent(swimTimeRecordId) : 'NaN';
    const url = `/Records/${swimTimeRecordIdForUrl}`;
    TimesHttpHelper(url, 'DELETE')
      .then((objData) => {
        if (!objData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            isObjLoading: false,
            isObjLoaded: true,
            isSaving: false,
            isSaved: true,
            objData,
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isObjLoading: false,
          isObjLoaded: false,
          isSaving: false,
          isSaved: false,
          message: message
        });
      });
  }
};

export default DeleteRecordTimeData;